module.exports = __webpack_public_path__ + "img/bg (1).7106869d.jpg";